import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, Image, StyleSheet } from 'react-native';
import downArrow from '../../../assets/down_arrow.png';
import usePersistentMenuState from '../../commons/usePersistentMenuState';


export const getNextStatusSelection = (currentStatuses = [], status, isShiftPressed = false) => {
  const selectedStatuses = Array.isArray(currentStatuses)
    ? currentStatuses.filter(Boolean)
    : [];

  if (selectedStatuses.includes(status)) {
    return selectedStatuses.filter(selectedStatus => selectedStatus !== status);
  }

  if (status === 'ScannedToday') {
    return ['ScannedToday'];
  }

  const statusesWithoutScannedToday = selectedStatuses.filter(
    selectedStatus => selectedStatus !== 'ScannedToday'
  );

  return isShiftPressed
    ? [...statusesWithoutScannedToday, status]
    : [status];
};

const getStatusCount = (counts, buttonName) => {
  const { awaiting, partially_scanned, scanned, cancelled, serviceissue,pick_in_progress,picked, onhold, scannedtoday, backordered } = counts;

  switch (buttonName.toLowerCase()) {
  case 'awaiting':
    return awaiting || 0;
  case 'cancelled':
    return cancelled || 0;
  case 'scanned':
    return scanned || 0;
  case 'scannedtoday':
    return scannedtoday || 0;
  case 'partiallyscanned':
    return partially_scanned || 0;
  case 'onhold':
    return onhold || 0;
  case 'serviceissue':
    return serviceissue || 0;
  case 'backordered':
    return backordered || 0;
  case 'pickinprogress':
  case 'pick_in_progress':
    return pick_in_progress || 0;
  case 'picked':
    return picked || 0;
  default:
    return 0;
  }
};

const CustomTouchableOpacity = ({ onPress, selectedStatus, handleStatusSelect, disableFilter, buttonName, buttonText, orderCount, inViewCount, testID }) => {
  const totalCount = orderCount ? getStatusCount(orderCount, buttonName) : 0;
  const hasInView = Boolean(inViewCount);
  const inViewValue = hasInView ? getStatusCount(inViewCount, buttonName) : '—';

  return (
    <TouchableOpacity onPress={onPress} style={{ paddingLeft: 5 }} testID={testID}>
      <View style={styles.buttonContainer}>
        <Text style={styles.buttonLabel}>{totalCount}</Text>
        <Text style={[handleStatusSelect?.includes(buttonName) && styles.dropdownActiveButton,
        styles.activeButtonLabel
        ]}>
          {buttonText || buttonName}
        </Text>
        <Text style={styles.inViewLabel} testID={testID + '_in_view'}>{inViewValue}</Text>
        <TouchableOpacity onPress={disableFilter} style={[{marginHorizontal: '1%'}]} testID={testID+'_reset'}>
        {handleStatusSelect.includes(selectedStatus) &&
          <i className="icon-cancel" style={{fontSize: '15px', color: 'gray'}}></i>
        }
        </TouchableOpacity>
      </View>
    </TouchableOpacity>
  );
};


const OrderStatusDropdown = ({getFilteredOrders, resetFilters, clearAllFilters, resetFilterCheck, status, orderCount, inViewCount, getScannedTodayOrders, isShiftPressed}) => {
  const [isOpen, toggleDropdown] = usePersistentMenuState('statusDropdown');
  const [selectedStatus, setSelectedStatus] = useState(() => status);


  const handleStatusSelect = (status, event) => {
    const shouldExtendSelection =
      Boolean(isShiftPressed) ||
      Boolean(event?.nativeEvent?.shiftKey) ||
      Boolean(event?.shiftKey);

    const statuses = getNextStatusSelection(
      selectedStatus,
      status,
      shouldExtendSelection
    );
    setSelectedStatus(statuses);
    resetFilters(statuses);
  };

  const handleScannedTodaySelect = () => {
    const statuses = getNextStatusSelection(selectedStatus, 'ScannedToday');
    setSelectedStatus(statuses);

    if (statuses?.length > 0) {
      getScannedTodayOrders ? getScannedTodayOrders() : getFilteredOrders(statuses);
      return;
    }

    resetFilters(statuses);
  };

  const disableFilter = (statusToRemove) => {
    let updatedStatus = [];
    setSelectedStatus(prevSelectedStatus => {
        updatedStatus = prevSelectedStatus.filter(status => status !== statusToRemove);
        return updatedStatus;
    });
    resetFilters(updatedStatus);
  };

  useEffect(() => {
      if(clearAllFilters === true)
      {
        setSelectedStatus([]);
        resetFilterCheck();
      }
  }, [clearAllFilters]);
  useEffect(() => {
      setSelectedStatus(status)
  }, [status]);

  return (
    <View style={{borderTop: '2px solid rgb(0, 0, 0)' , marginTop: '1rem'}}>
      <TouchableOpacity style={styles.statusDropDownButton} onPress={toggleDropdown}>
        <View style={styles.statusButtonContainer}>
          <Text style={styles.statusLabel}>
            Status
          </Text>
          <Image style={[styles.dateRangeImage, isOpen && styles.iconOpen]} source={downArrow} />
        </View>

      </TouchableOpacity>
      {isOpen && (
        <View style={{ marginTop: 10 }}>
          <View style={styles.columnHeaderRow}>
            <Text style={styles.columnHeaderLabel}>Total</Text>
            <Text style={[styles.columnHeaderLabel, styles.columnHeaderStatus]}>Status</Text>
            <Text style={[styles.columnHeaderLabel, styles.columnHeaderInView]}>In View</Text>
          </View>
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('Awaiting', event)}
            selectedStatus={'Awaiting'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('Awaiting')}}
            buttonName="Awaiting"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="awaiting_button"
          />
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('Scanned', event)}
            selectedStatus={'Scanned'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('Scanned')}}
            buttonName="Scanned"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="scanned_button"
          />
          <CustomTouchableOpacity
            onPress={handleScannedTodaySelect}
            selectedStatus={'ScannedToday'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('ScannedToday')}}
            buttonName="ScannedToday"
            buttonText="Scanned Today"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="scanned_today_button"
          />
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('Cancelled', event)}
            selectedStatus={'Cancelled'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('Cancelled')}}
            buttonName="Cancelled"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="cancelled_button"
          />
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('ServiceIssue', event)}
            selectedStatus={'ServiceIssue'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('ServiceIssue')}}
            buttonName="ServiceIssue"
            buttonText="Service Issue"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="service_issue_button"
          />
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('PartiallyScanned', event)}
            selectedStatus={'PartiallyScanned'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('PartiallyScanned')}}
            buttonName="PartiallyScanned"
            buttonText="Partially Scanned"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="partically_scanned_button"
          />
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('Backordered', event)}
            selectedStatus={'Backordered'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('Backordered')}}
            buttonName="Backordered"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="backordered_button"
          />
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('OnHold', event)}
            selectedStatus={'OnHold'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('OnHold')}}
            buttonName="OnHold"
            buttonText="Action Required"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="action_required_button"
          />
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('pick_in_progress', event)}
            selectedStatus={'pick_in_progress'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('pick_in_progress')}}
            buttonName="pick_in_progress"
            buttonText="Pick in Progress"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="pick_in_progress_button"
          />
          <CustomTouchableOpacity
            onPress={event => handleStatusSelect('Picked', event)}
            selectedStatus={'Picked'}
            handleStatusSelect={selectedStatus}
            disableFilter={() => {disableFilter('Picked')}}
            buttonName="Picked"
            orderCount={orderCount}
            inViewCount={inViewCount}
            testID="picked_button"
          />
        </View>
      )}
    </View>
  );
};


const styles = StyleSheet.create({
  dropdownActiveButton: {
    border: '1px solid gray',
    borderRadius: 8,
    paddingTop: 2,
  },
  dateRangeImage: {
    width: 15,
    height: 15,
    marginRight: '4%',
    marginTop: '1.5%',
    color: 'gray'
  },
  iconOpen: {
    transform: [{rotate: '180deg'}]
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems:'center'
  },
  buttonLabel:{
    color: 'white',
    width: '16%',
    fontSize: '12px',
    textAlign: 'right'
  },
  activeButtonLabel:{
    color: 'white',
    paddingBottom: 2,
    fontSize: '15px',
    paddingLeft: 10,
    width: '65%',
    marginLeft: '1%',
    fontFamily: 'Poppins_300Light',
    marginBottom: '2px'
  },
  inViewLabel: {
    color: '#9BA7B4',
    width: '14%',
    fontSize: '12px',
    textAlign: 'right',
    marginRight: 12
  },
  columnHeaderRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    paddingLeft: 5,
    marginBottom: 4
  },
  columnHeaderLabel: {
    color: '#9BA7B4',
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 11,
    width: '16%',
    textAlign: 'right'
  },
  columnHeaderStatus: {
    width: '65%',
    marginLeft: '1%',
    paddingLeft: 10,
    textAlign: 'left'
  },
  columnHeaderInView: {
    marginRight: 12
  },
  statusLabel: {
    color: '#9BA7B4',
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 13,
    padding: 5
  },
  statusDropDownButton: {
    maxWidth: '107%',
    backgroundColor: '#262B30',
    marginLeft: '-1px'
  },
  statusButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});


export default OrderStatusDropdown;
